import { render, staticRenderFns } from "./PartnerDashboard.vue?vue&type=template&id=12af6e2d&"
import script from "./PartnerDashboard.vue?vue&type=script&lang=js&"
export * from "./PartnerDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports